/**
 * Scroll the main document to the top. Use after cleaner flow steps, wizard step changes,
 * or "next category" actions so mobile users see the new content from the top.
 */
export function scrollRootToTop(): void {
  if (typeof window === "undefined") return;
  const run = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const root = document.scrollingElement ?? document.documentElement;
    if (root) root.scrollTop = 0;
    document.body.scrollTop = 0;
  };
  run();
  requestAnimationFrame(run);
}
